
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[franchiseeSlug]/about",
      function () {
        return require("private-next-pages/[franchiseeSlug]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[franchiseeSlug]/about"])
      });
    }
  